<template>
  <div
    class="
      date-filter
      ivu-input-group
      ivu-input-group-with-prepend
    ">
    <div class="ivu-input-group-prepend">
      <iSelect
        slot="prepend"
        v-model="op"
        placeholder=""
        size="small"
        style="width: 50px"
        transfer
        @on-change="onOpChange"
      >
        <i-option
          v-for="op in operations"
          :key="op.value"
          :value="op.value"
          :label="op.label"
        />
      </iSelect>
    </div>

    <iDatePicker
      :value="date"
      type="date"
      size="small"
      placeholder=""
      transfer
      @on-change="onDateChange"
    />
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'DateFilter',
  model: {
    event: 'change',
  },
  props: {
    value: { type: Object, default: null },
    opts: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      operations: [
        { value: 'eq', label: '=' },
        { value: 'lte', label: '<=' },
        { value: 'gte', label: '>=' },
        { value: 'ne', label: '!=' },
        { value: 'lt', label: '<' },
        { value: 'gt', label: '>' },
      ],
      date: null,
      op: null,
    };
  },
  watch: {
    value: {
      handler() {
        const { query, op } = this.value || {};
        this.op = op || this.op || this.operations[2].value;
        this.date = query;
      },
      immediate: true,
    },
  },
  methods: {
    onOpChange() {
      this.op = this.op || this.operations[2].value;
      this.change();
    },
    onDateChange(formated) {
      // Fix Workaround problem datepicker with time zones
      this.date = formated ? moment(formated, 'YYYY-MM-DD').add(1, 'day').format('YYYY-MM-DD') : null;
      this.change();
    },
    change() {
      this.$emit('change', this.date ? {
        op: this.op,
        query: this.date,
      } : null);
    },
  },
};
</script>

<style>
.date-filter.ivu-input-group {
  top: 0px;
}
</style>
